// extracted by mini-css-extract-plugin
module.exports = {"container":"modal-footer_container__kmtRa","tagLink":"modal-footer_tagLink__tnpq8","address":"modal-footer_address__BGwYB","socialList":"modal-footer_socialList__XdIAu"};